import { Bell, CheckCircle2, Clock, GitBranch, Users } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import type { PaletteItem, StepDraft } from './model'

export interface StepMeta {
  label: string
  hint: string
  icon: LucideIcon
  /** Background for the icon tile — the app's tint tokens, so dark mode follows. */
  tint: string
  /** Icon colour. */
  tone: string
}

export const PALETTE: Record<PaletteItem, StepMeta> = {
  APPROVAL: {
    label: 'Approval', hint: 'One person approves or rejects', icon: CheckCircle2,
    tint: 'bg-[var(--color-tint-blue)]', tone: 'text-[var(--color-info)]',
  },
  PARALLEL: {
    label: 'Parallel Approval', hint: 'Several approvers at once', icon: Users,
    tint: 'bg-[var(--color-tint-purple)]', tone: 'text-[var(--color-primary)]',
  },
  NOTIFICATION: {
    label: 'Notification', hint: 'Send a notification and move on', icon: Bell,
    tint: 'bg-[var(--color-tint-orange)]', tone: 'text-[var(--color-warning)]',
  },
  CONDITION: {
    label: 'Condition', hint: 'Run the steps below only when the record matches', icon: GitBranch,
    tint: 'bg-[var(--color-tint-green)]', tone: 'text-[var(--color-success)]',
  },
  DELAY: {
    label: 'Delay', hint: 'Wait for a while, then continue', icon: Clock,
    tint: 'bg-[var(--color-tint-red)]', tone: 'text-[var(--color-danger)]',
  },
}

/** Which palette card a step came from — an approval asking several at once is "Parallel". */
export function paletteOf(step: StepDraft): PaletteItem {
  if (step.kind === 'APPROVAL') return step.mode === 'SEQUENTIAL' ? 'APPROVAL' : 'PARALLEL'
  return step.kind
}

export const APPROVAL_ITEMS: PaletteItem[] = ['APPROVAL', 'PARALLEL', 'NOTIFICATION', 'CONDITION', 'DELAY']
